var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjecting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15,12.5c0,1.657-1.343,3-3,3s-3-1.343-3-3,1.343-3,3-3,3,1.343,3,3Zm1-8.5L12,0l-4,4,4,4,4-4Zm-7,19h6v-6h-6v6Zm-4-5.938v2h-1.5c-.276,0-.5-.225-.5-.5v-4.062c0-.275.224-.5.5-.5h3.5v-3h-3.5c-1.93,0-3.5,1.57-3.5,3.5v4.062c0,1.93,1.57,3.5,3.5,3.5h1.5v2l2.78-2.95c.293-.304.293-.796,0-1.1l-2.78-2.95ZM20.5,2h-2.5v3h2.5c.276,0,.5.224.5.5v5c0,.276-.224.5-.5.5h-1.5v-2l-2.78,2.95c-.293.304-.293.796,0,1.1l2.78,2.95v-2h1.5c1.93,0,3.5-1.57,3.5-3.5v-5c0-1.93-1.57-3.5-3.5-3.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjecting);
export default __webpack_public_path__ + "static/media/projecting.4813eb591263f7e464048f554870c317.svg";
export { ForwardRef as ReactComponent };